import React from "react";

const Limitations = () => {
  return (
    <div className="flex flex-col items-start sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide ">
        L.
        <span className="text-[#01A7D1] "> LIMITATIONS OF LIABILITY</span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <span className="text-lg font-medium">
          IN NO EVENT SHALL Yostel, OR ITS RESPECTIVE OFFICERS, MANAGERS,
          MEMBERS, DIRECTORS, EMPLOYEES, SUCCESSORS, ASSIGNS, SUBSIDIARIES,
          AFFILIATES, SUPPLIERS, ATTORNEYS OR AGENTS, BE LIABLE TO YOU FOR ANY
          DIRECT, INDIRECT, INCIDENTAL, SPECIAL, PUNITIVE, CONSEQUENTIAL OR
          EXEMPLARY DAMAGES (INCLUDING BUT NOT LIMITED TO LOSS OF BUSINESS,
          REVENUE, PROFITS, USE, DATA OR OTHER ECONOMIC ADVANTAGE) WHATSOEVER
          RESULTING FROM (I) ANY ERRORS, MISTAKES, OR INACCURACIES OF DATA,
          MARKS, CONTENT, INFORMATION, MATERIALS OR SUBSTANCE OF THE PLATFORM OR
          SUBMITTED CONTENT; (II) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR
          SECURE SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION AND/OR
          FINANCIAL INFORMATION STORED THEREIN; (III) ANY BUGS, VIRUSES, TROJAN
          HORSES, OR THE LIKE WHICH MAY BE TRANSMITTED TO OR THROUGH THE
          PLATFORM ; (IV) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR
          FROM THE PLATFORM; (V) ANY ERRORS OR OMISSIONS IN ANY DATA, CONTENT,
          INFORMATION, MATERIALS OR SUBSTANCE OF THE PLATFORM OR SUBMITTED
          CONTENT; (VI) ANY DEFAMATORY, OFFENSIVE, OR ILLEGAL CONDUCT OF ANY
          THIRD PARTY; OR (VII) ANY USE OF ANY DATA, MARKS, CONTENT,
          INFORMATION, MATERIALS OR SUBSTANCE OF THE PLATFORM OR SUBMITTED
          CONTENT POSTED, EMAILED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE ON
          OR THROUGH THE PLATFORM, WHETHER BASED ON WARRANTY, CONTRACT, TORT
          (INCLUDING NEGLIGENCE), OR ANY OTHER LEGAL THEORY, AND WHETHER OR NOT
          Yostel IS ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. THE FOREGOING
          LIMITATION OF LIABILITY SHALL APPLY TO THE FULLEST EXTENT PERMITTED BY
          LAW IN THE APPLICABLE JURISDICTION.
        </span>
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <span className="text-lg font-medium">
          IN NO EVENT SHALL THE TOTAL, AGGREGATE LIABILITY OF Yostel, OR ANY OF
          THE ABOVE-REFERENCED RESPECTIVE PARTIES, ARISING FROM OR RELATING TO
          THE PLATFORM, AND/OR SUBMITTED CONTENT EXCEED THE SIX-MONTH FEES
          ACTUALLY PAID TO YOSTEL BY YOU.
        </span>
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <span className="text-lg font-medium">
          FORCE MAJEURE- NEITHER YOSTEL NOR YOU SHALL BE LIABLE TO THE OTHER FOR
          ANY DELAY OR FAILURE IN PERFORMANCE UNDER THE TERMS OF USE, OTHER THAN
          PAYMENT OBLIGATIONS, ARISING OUT OF A CAUSE BEYOND ITS CONTROL AND
          WITHOUT ITS FAULT OR NEGLIGENCE. SUCH CAUSES MAY INCLUDE, BUT ARE NOT
          LIMITED TO FIRES, FLOODS, EARTHQUAKES, STRIKES, UNAVAILABILITY OF
          NECESSARY UTILITIES, BLACKOUTS, ACTS OF GOD, ACTS OF DECLARED OR
          UNDECLARED WAR, ACTS OF REGULATORY AGENCIES, OR NATIONAL DISASTERS.
        </span>
      </p>
    </div>
  );
};

export default Limitations;
